module.exports = __webpack_public_path__ + "static/media/sight-issues.b1df22bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/toolbars/NavBarNew/sight-issues.svg
// module id = 4392
// module chunks = 7